import { render, staticRenderFns } from "./ConfigCreateuserForm.vue?vue&type=template&id=0c1b8d40&scoped=true"
import script from "./ConfigCreateuserForm.vue?vue&type=script&lang=js"
export * from "./ConfigCreateuserForm.vue?vue&type=script&lang=js"
import style0 from "./ConfigCreateuserForm.vue?vue&type=style&index=0&id=0c1b8d40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1b8d40",
  null
  
)

export default component.exports